import React from 'react';
import RouteRenderer from './RouteRenderer';

export default class SimpleRoute extends React.Component {
  render() {
    return <RouteRenderer hasAccess {...this.props} />;
  }
}
